import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import ToggleButtonListItem from '../../../../../../list-items/ToggleButtonListItem';
import { PARTICLE_DIRECTIONS } from '../../../../Preview/PreviewDisplayConstants';

const particleDirectionOptions = [
    {value: PARTICLE_DIRECTIONS.RIGHT, text: 'Right'},
    {value: PARTICLE_DIRECTIONS.LEFT, text: 'Left'},
    {value: PARTICLE_DIRECTIONS.UP, text: 'Up'},
    {value: PARTICLE_DIRECTIONS.DOWN, text: 'Down'},
    {value: PARTICLE_DIRECTIONS.OUT, text: 'Out'},
    {value: PARTICLE_DIRECTIONS.FLOCK, text: 'Flock'},
];

const ParticlesDirectionListItem = (props) => {
    const { particlesDirection, updateElementsSettings } = props;
    
    const onDirectionChange = (value) => updateElementsSettings({ 
        particles: { direction: value }
    });

    return (
        <ToggleButtonListItem
            text='Direction'
            value={particlesDirection}
            onChange={onDirectionChange}
            options={particleDirectionOptions}
            lineBreak
        />
    );
};

const mapStateToProps = (state) => {
    const { direction: particlesDirection } = state.createPreview.present.videoSettings.elements.particles;
    return { particlesDirection };
}

const mapDispatchToProps = (dispatch) => {
    const updateElementsSettings = (properties) => dispatch(createActions.updateElementsSettings(properties));
    return { updateElementsSettings }
}

export default connect(mapStateToProps, mapDispatchToProps)(ParticlesDirectionListItem);